<template>
  <div>
    <div class="site-banner">
      <div class="banner-major"> 
        <div class="container">
          <div class="site-banner-product"> 
            <div class="site-banner-detail invert">
              <div class="detail-box-left">
                <h3>{{ text1[0] }}</h3>
                <h5>{{ text1[1] }}</h5>
                <a class="btn btn--contact btn--square btncall btn--center" :href="item.section_value.bannerright_link">{{ item.section_value.bannerright_title_link }}</a>
              </div>
              <div class="detail-box-right">
                <figure>
                  <img :src="currentUrl + '/img/sale_page_single/' + item.section_value.bannerright_image">
                </figure>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['currentUrl']),
    text1(){
      return this.item.section_value.bannerright_text.split('\r\n');
    }
  }
}
</script>

<style lang="scss" scoped>
</style>